<template>
  <div
    class="fe-area-select-group"
  >
    <fe-area-select
      v-for="(item, key) in options"
      v-if="showSelect(item.level)"
      v-role="{regionLevel5Switch,level:item.level}"
      :show="showSelect(item.level)"
      :key="key"
      :placeholder="item.placeholder"
      :title="item.label"
      :value="item.value"
      :level="item.level"
      v-model="item.value"
      :label-name="key"
      :path="path"
      :name="name"
      :params="item.params"
      :ref="key"
    >

    </fe-area-select>
  </div>

</template>
<script>
  import role from '@/mixins/role'
  import areaSelect from './area/areaSelect.vue'
  export default {
    name: 'fe-area-select-group',
    components: {
      'fe-area-select': areaSelect
    },
    mixins: [role],
    props: {
      name: {
        type: String,
        required: true
      },
      path: {
        type: String,
        required: true
      },
      level: {
        type: Array,
        default() {
          return [1, 2, 3]
        }
      },
      value: {
        type: Array,
        default() {
          return []
        }
      },
      validate: {
        type: Object,
        default() {
          return {
            required: true
          }
        }
      }
      // maxLength: {
      //   type: Number,
      //   default() {
      //     return 1800
      //   }
      // }
    },
    data() {
      return {
        selectValues: [],
        options: {
          'province': {
            placeholder: '请选择省份',
            label: '省份',
            value: [],
            regionCodes: [],
            level: 1,
            params: {}
          },
          'city': {
            placeholder: '请选择城市',
            label: '城市',
            value: [],
            level: 2,
            params: {}
          },
          'county': {
            placeholder: '请选择区县',
            label: '区县',
            value: [],
            level: 3,
            params: {
            }
          },
          'town': {
            placeholder: '请选择乡镇',
            label: '乡镇',
            value: [],
            level: 4,
            params: {
            }
          },
          'village': {
            placeholder: '请选择村',
            label: '村',
            value: [],
            level: 5,
            params: {
            }
          }
        }
      }
    },
    computed: {
      required() {
        return !!(this.validate && this.validate.required)
      }
    },
    watch: {
      'options.province.value': function(val) {
        // if (val.length > 0) {
        this.$set(this.options.city.params, 'regionCodes', val)
        this.$refs.city && this.$refs.city[0].getData()
        /* this.$set(this.options.county.params, 'regionCodes', val)
        this.$refs.county && this.$refs.county[0].getData()
        this.$set(this.options.town.params, 'regionCodes', val)
        this.$refs.town && this.$refs.town[0].getData()
        this.$set(this.options.village.params, 'regionCodes', val)
        this.$refs.village && this.$refs.village[0].getData()*/
        // }
        this.$refs.city && this.$refs.city[0].removeAll()
        /* this.$refs.county && this.$refs.county[0].removeAll()
        this.$refs.town && this.$refs.town[0].removeAll()
        this.$refs.village && this.$refs.village[0].removeAll() */
        this.selectValues = val
      },
      'options.city.value': function(val) {
        this.$refs.county && this.$refs.county[0].removeAll()
        this.$set(this.options.county.params, 'regionCodes', val)
        this.$refs.county && this.$refs.county[0].getData()
        /* this.$set(this.options.town.params, 'regionCodes', val)
        this.$refs.town && this.$refs.town[0].getData()
        this.$set(this.options.village.params, 'regionCodes', val)
        this.$refs.village && this.$refs.village[0].getData()*/
        if (val.length > 0) {
          this.selectValues = val
        } else {
          if (this.$refs.province && this.$refs.province[0].value.length > 0) {
            this.selectValues = this.$refs.province[0].value
          } else {
            this.selectValues = []
          }
        }
      },
      'options.county.value': function(val) {
        this.$refs.town && this.$refs.town[0].removeAll()
        this.$set(this.options.town.params, 'regionCodes', val)
        this.$refs.town && this.$refs.town[0].getData()
        /* this.$set(this.options.village.params, 'regionCodes', val)
        this.$refs.village && this.$refs.village[0].getData()*/
        if (val.length > 0) {
          this.selectValues = val
        } else {
          if (this.$refs.city && this.$refs.city[0].value.length > 0) {
            this.selectValues = this.$refs.city[0].value
          } else if (this.$refs.province && this.$refs.province[0].value.length > 0) {
            this.selectValues = this.$refs.province[0].value
          } else {
            this.selectValues = []
          }
        }
      },
      'options.town.value': function(val) {
        this.$refs.village && this.$refs.village[0].removeAll()
        this.$set(this.options.village.params, 'regionCodes', val)
        this.$refs.village && this.$refs.village[0].getData()
        if (val.length > 0) {
          this.selectValues = val
        } else {
          if (this.$refs.county && this.$refs.county[0].value.length > 0) {
            this.selectValues = this.$refs.county[0].value
          } else if (this.$refs.city && this.$refs.city[0].value.length > 0) {
            this.selectValues = this.$refs.city[0].value
          } else if (this.$refs.province && this.$refs.province[0].value.length > 0) {
            this.selectValues = this.$refs.province[0].value
          } else {
            this.selectValues = []
          }
        }
      },
      'options.village.value': function(val) {
        if (val.length > 0) {
          this.selectValues = val
        } else {
          if (this.$refs.town && this.$refs.town[0].value.length > 0) {
            this.selectValues = this.$refs.town[0].value
          } else if (this.$refs.county && this.$refs.county[0].value.length > 0) {
            this.selectValues = this.$refs.county[0].value
          } else if (this.$refs.city && this.$refs.city[0].value.length > 0) {
            this.selectValues = this.$refs.city[0].value
          } else if (this.$refs.province && this.$refs.province[0].value.length > 0) {
            this.selectValues = this.$refs.province[0].value
          } else {
            this.selectValues = []
          }
        }
      },
      selectValues: {
        handler(val) {
          // if (val.length > this.maxLength) {
          //   this.$message.error('选择长度超过设定长度')
          //   this.$nextTick(() => {
          //     this.clearAll()
          //   })
          // } else {
          this.$emit('input', val)
          // }
        }
      },
      value: {
        handler(val) {
          this.selectValues = val
          if (val.length === 0) {
            this.reset()
          }
        }
      }
    },
    methods: {
      showSelect(level) {
        if (~this.level.indexOf(level)) {
          return true
        } else {
          return false
        }
      },
      clearAll() {
        if (this.$refs.province) {
          this.$refs.province[0].defaultValue = []
        }
        if (this.$refs.city) {
          this.$refs.city[0].defaultValue = []
        }
        if (this.$refs.county) {
          this.$refs.county[0].defaultValue = []
        }
        if (this.$refs.town) {
          this.$refs.town[0].defaultValue = []
        }
        if (this.$refs.village) {
          this.$refs.village[0].defaultValue = []
        }
      },
      reset() {
        this.clearAll()
        this.$set(this.options.province.params, 'regionCodes', [])
        this.$set(this.options.city.params, 'regionCodes', [])
        this.$set(this.options.county.params, 'regionCodes', [])
        this.$set(this.options.town.params, 'regionCodes', [])
        this.$set(this.options.village.params, 'regionCodes', [])
      }
    }
  }
</script>
<style type="text/scss" lang="scss" scoped>
  .fe-area-select-group{
    display: flex;
    flex-wrap: wrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/FromBase/areaSelectGroup.vue